import { Node, mergeAttributes } from '@tiptap/core';

/**
 * Inline atom for a merge field. Serialized as
 * <span data-merge="token" data-label="Label">Label</span>, which the server
 * replaces whole; the label is only what the drafter sees.
 */
export const MergeFieldNode = Node.create({
  name: 'mergeField',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      token: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-merge'),
      },
      label: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute('data-label')
          || (element.textContent || '').replace(/^\[|\]$/g, '').replace(/^\{\{|\}\}$/g, ''),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-merge]' }];
  },

  renderHTML({ node }) {
    const label = node.attrs.label || node.attrs.token || '';
    return [
      'span',
      mergeAttributes({
        'data-merge': node.attrs.token,
        'data-label': label,
        class: 'merge-chip',
        title: `{{${node.attrs.token}}}`,
      }),
      label,
    ];
  },

  renderText({ node }) {
    return `{{${node.attrs.token}}}`;
  },
});

export default MergeFieldNode;
